import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getTranslation } from 'common/react/utils/translations';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';
import { InsOutsPlayer } from 'widgets/team-lineups-condensed/js/components/InsOuts/InsOutsPlayer';
import { TeamLineupsContext } from 'widgets/mc-team-lineups/js/components/MCTeamLineups';

/**
 * Renders a milestones component.
 *
 * @param match.match
 * @param {object} match The match data.
 * @param match.teamDisplay
 * @param match.selectedTabView
 * @returns {JSX.Element} The milestone component.
 */
export const Milestones = ({ match, teamDisplay, selectedTabView }) => {
    const teamLineupsContext = useContext(TeamLineupsContext);

    const { homeTeam, awayTeam } = match.matchRoster;

    const homeTeamMilestones = homeTeam?.milestones.filter(
        (item) =>
            item.milestoneEvent !== 'Debut game' ||
            !homeTeam.clubDebuts.find(
                (debut) => debut.player.playerId === item.player.playerId
            )
    );

    const awayTeamMilestones = awayTeam?.milestones.filter(
        (item) =>
            item.milestoneEvent !== 'Debut game' ||
            !awayTeam.clubDebuts.find(
                (debut) => debut.player.playerId === item.player.playerId
            )
    );

    if (
        !homeTeamMilestones.length &&
        !awayTeamMilestones.length &&
        teamLineupsContext !== 'match-centre'
    ) {
        return null;
    }

    const renderMilestoneEvent = (milestoneEvent, isLast) => {
        return (
            <React.Fragment key={milestoneEvent.player.playerId}>
                {teamDisplay &&
                teamDisplay !== PULSE.app.common.CONSTANTS.TEAM.BOTH &&
                selectedTabView === PULSE.app.common.CONSTANTS.VIEWS.FIELD ? (
                    <InsOutsPlayer
                        player={milestoneEvent.player}
                        reason={milestoneEvent.milestoneEvent}
                        match={match}
                    />
                ) : (
                    <>
                        <PlayerProfileLink
                            player={{
                                playerId: milestoneEvent.player.playerId,
                                firstName:
                                    milestoneEvent.player.playerName.givenName,
                                surname:
                                    milestoneEvent.player.playerName.surname
                            }}
                        >
                            {`${milestoneEvent.player.playerName.givenName} ${milestoneEvent.player.playerName.surname} (${milestoneEvent.milestoneEvent})`}
                        </PlayerProfileLink>
                        {!isLast ? ', ' : ''}
                    </>
                )}
            </React.Fragment>
        );
    };

    return (
        <div
            className={`team-lineups-ins-and-outs ${
                (teamDisplay === PULSE.app.common.CONSTANTS.TEAM.HOME ||
                    teamDisplay === PULSE.app.common.CONSTANTS.TEAM.AWAY) &&
                selectedTabView === PULSE.app.common.CONSTANTS.VIEWS.FIELD
                    ? `team-lineups-ins-and-outs--single`
                    : ``
            }`}
        >
            {/* Mobile Title */}
            <div className="team-lineups__title-section u-hide-from-tablet">
                <span className="team-lineups__title">
                    {getTranslation('label.teamlineups.milestones')}
                </span>
            </div>
            <div
                className={`team-lineups__grid team-lineups__grid--${teamDisplay}`}
            >
                {(teamDisplay !== PULSE.app.common.CONSTANTS.TEAM.AWAY ||
                    selectedTabView ===
                        PULSE.app.common.CONSTANTS.VIEWS.LIST) && (
                    <div className="team-lineups__event-text team-lineups__event-text--home">
                        {homeTeamMilestones.length ? (
                            homeTeamMilestones.map((item, i) =>
                                renderMilestoneEvent(
                                    item,
                                    i + 1 === homeTeamMilestones.length
                                        ? true
                                        : false
                                )
                            )
                        ) : (
                            <>&ndash;</>
                        )}
                    </div>
                )}

                <div className="team-lineups__title-section u-hide-until-tablet">
                    <span className="team-lineups__title">
                        {getTranslation('label.teamlineups.milestones')}
                    </span>
                </div>

                {(teamDisplay !== PULSE.app.common.CONSTANTS.TEAM.HOME ||
                    selectedTabView ===
                        PULSE.app.common.CONSTANTS.VIEWS.LIST) && (
                    <div className="team-lineups__event-text team-lineups__event-text--away">
                        {awayTeamMilestones.length ? (
                            awayTeamMilestones.map((item, i) =>
                                renderMilestoneEvent(
                                    item,
                                    i + 1 === awayTeamMilestones.length
                                        ? true
                                        : false
                                )
                            )
                        ) : (
                            <>&ndash;</>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

Milestones.propTypes = {
    match: PropTypes.object.isRequired,
    teamDisplay: PropTypes.string,
    selectedTabView: PropTypes.string.isRequired
};
